import React from 'react';
import ExitToApp from '@material-ui/icons/ExitToApp';
import { MenuItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Oauth from '../../../providers/Auth0Provider/Auth0Provider';
function HeaderLogoutBtn() {
    var t = useTranslation().t;
    return (React.createElement(MenuItem, { id: "logoutLink", onClick: function () { return Oauth.logout(); } },
        React.createElement(ListItemIcon, { style: { minWidth: '33px' } },
            React.createElement(ExitToApp, { color: "primary" })),
        React.createElement(ListItemText, { primary: t('Logout') })));
}
export default HeaderLogoutBtn;
//# sourceMappingURL=HeaderLogoutBtn.js.map